<div *appIsDesktop id="lnOrderDetailsContainer">
  <ds-divider></ds-divider>

  <div id="lnOrderDetails" class="table-container">
    @if (lnOrderDetailsResult?.length) {
      <div id="lnOrderDetailsTableWrapper">
        <!-- LN Order Items table -->
        <ds-table id="LNOrderTable" mat-table [dataSource]="lnOrderDetailsResult"
          [displayedColumns]="displayedColumns">
          <!-- ERP Line # -->
          <ng-container matColumnDef="erp">
            <th id="ERPLine" mat-header-cell *matHeaderCellDef>
              {{ appStrings.invoice_table_erp }}
            </th>
            <td [id]="'lineNumber_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex">
              {{ lnOrder.lineNumber }}
            </td>
          </ng-container>
          <!-- LN Order Item -->
          <ng-container matColumnDef="item">
            <th id="LNOrderItemHeader" mat-header-cell *matHeaderCellDef>
              {{ appStrings.lnOrder_table_partNumber }}
            </th>
            <td [id]="'lnItem_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex">
              {{ lnOrder.item }}
            </td>
          </ng-container>
          <!-- Item Description -->
          <ng-container matColumnDef="description">
            <th id="itemDescriptionHeader" mat-header-cell *matHeaderCellDef>
              {{ appStrings.invoice_table_description }}
            </th>
            <td [id]="'lnItemDescription_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex">
              {{ lnOrder.description }}
            </td>
          </ng-container>
          <!-- Shipped Quantity -->
          <ng-container matColumnDef="shipQuantity">
            <th id="shipQuantityHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{ appStrings.invoice_table_shipQuantity }}
            </th>
            <td [id]="'shippedQty_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex" class="text-right">
              {{ lnOrder.quantityShipped ? lnOrder.quantityShipped : '0'}}
            </td>
          </ng-container>
          <!-- Backorder Quantity -->
          <ng-container matColumnDef="backOrderQuantity">
            <th id="backOrderQtyHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{ appStrings.invoice_table_backQuantity }}
            </th>
            <td [id]="'backOrderQty_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex" class="text-right">
              {{ lnOrder.backorderQuantity }}
            </td>
          </ng-container>
          <!-- Order Quantity -->
          <ng-container matColumnDef="orderQuantity">
            <th id="orderQtyHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{ appStrings.invoice_table_orderQuantity }}
            </th>
            <td [id]="'orderQty_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex" class="text-right">
              {{ lnOrder.orderedQuantity }}
            </td>
          </ng-container>
          <!-- Tracking Number -->
          <ng-container matColumnDef="trackingNumber">
            <th id="trackingNumberHeader" mat-header-cell *matHeaderCellDef class="text-center">
              {{ appStrings.invoice_trackingNumber }}
            </th>
            <td [id]="'trackingNumber_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex" class="text-center">
              {{ lnOrder.trackingNumber ? lnOrder.trackingNumber : '-' }}
            </td>
          </ng-container>
          <!-- Net Price -->
          <ng-container matColumnDef="netPrice">
            <th id="netPriceHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{ appStrings.products_netPrice }}
            </th>
            <td [id]="'netPrice'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex" class="text-right">
              {{ lnOrder.netPrice | currency: currencySymbol }}
            </td>
          </ng-container>
          <!-- Total Price -->
          <ng-container matColumnDef="totalPrice">
            <th id="totalNetPriceHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{ appStrings.invoice_table_totalPrice }}
            </th>
            <td [id]="'totalPrice_'+i" mat-cell *matCellDef="let lnOrder; let i=dataIndex" class="text-right">
              {{ lnOrder.totalNet | currency: currencySymbol }}
            </td>
          </ng-container>
        </ds-table>
        <div id="paginatorContainer" class="flex-container">
          <div id="pageCount" class="page-count flex-item">
            <b>{{ pageOffset + 1 }} - {{ pageOffset + totalRecords }}</b> {{appStrings.pagination_of}} <b>{{ totalRecords }}</b>
          </div>
          @if (dataLoaded.orderDetails) {
            <ds-pagination
              id="lnOrderDetailsPaginator"
              [totalPages]="totalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          }
          <div class="flex-item"></div>
        </div>
      </div>
    } @else {
      <div id="noResultsMessage">{{ appStrings.noEntriesFound }}</div>
    }

  </div>
</div>

<div *appIsMobile id="lnOrderDetailsContainer-mobile" class="mobile">
  <ds-divider></ds-divider>

  @if (lnOrderDetailsResult?.length) {
    <div id="lnOrderDetails-mobile">
      @for (lnOrder of lnOrderDetailsResult; track lnOrder; let i = $index) {
        <mat-expansion-panel [id]="'lnOrderDetailCard_'+i" class="mobile-card two-columns grey tall blue-border" [expanded]="false"
          >
          <mat-expansion-panel-header [id]="'lnOrderDetailCardHeader_'+i" class="full-height">
            <mat-panel-title [id]="'ln-order-detail-card-header-container_'+i" class="card-header-container">
              <span [id]="'ln-order-detail-card-header_'+i" class="card-header">
                <span [id]="'ln-order-detail-card-title_'+i" class="title">
                  #{{lnOrder.lineNumber}} - {{lnOrder.item}}
                </span>
                <div [id]="'lnOrderDetailCardRowHeader_'+i" class="row">
                  <div [id]="'lnOrderDetailCardRowHeaderCol1_'+i" class="column full-width">
                    <typography [id]="'description_label_'+i" class="label" variant="caption-2" weight="regular">
                      {{appStrings.invoice_table_description}}
                    </typography>
                    <typography [id]="'description_'+i" variant="body-2" weight="medium">
                      {{lnOrder.description}}
                    </typography>
                  </div>
                </div>
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div [id]="'lnOrderDetailCardContent_'+i">
            <div [id]="'lnOrderDetailCardRow1_'+i" class="row">
              <div [id]="'lnOrderDetailCardRow1Col1_'+i" class="column">
                <typography [id]="'shipQuantity_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_shipQuantity}}
                </typography>
                <typography [id]="'shipQuantity_'+i" variant="body-2" weight="medium">
                  {{lnOrder.quantityShipped ? lnOrder.quantityShipped : '0'}}
                </typography>
              </div>
              <div [id]="'lnOrderDetailCardRow1Col2_'+i" class="column">
                <typography [id]="'backOrderQuantity_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_backQuantity}}
                </typography>
                <typography [id]="'backOrderQuantity_'+i" variant="body-2" weight="medium">
                  {{lnOrder.backorderQuantity}}
                </typography>
              </div>
            </div>
            <div [id]="'lnOrderDetailCardRow2_'+i" class="row">
              <div [id]="'lnOrderDetailCardRow2Col1_'+i" class="column">
                <typography [id]="'orderQuantity_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_orderQuantity}}
                </typography>
                <typography [id]="'orderQuantity_'+i" variant="body-2" weight="medium">
                  {{lnOrder.orderedQuantity}}
                </typography>
              </div>
              <div [id]="'lnOrderDetailCardRow2Col2_'+i" class="column">
                <typography [id]="'trackingNumber_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_trackingNumber}}
                </typography>
                <typography [id]="'trackingNumber_'+i" variant="body-2" weight="medium">
                  {{lnOrder.trackingNumber ? lnOrder.trackingNumber : '-'}}
                </typography>
              </div>
            </div>
            <div [id]="'lnOrderDetailCardRow3_'+i" class="row">
              <div [id]="'lnOrderDetailCardRow3Col1_'+i" class="column">
                <typography [id]="'netPrice_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.products_netPrice}}
                </typography>
                <typography [id]="'netPrice_'+i" variant="body-2" weight="medium">
                  {{lnOrder.netPrice | currency: currencySymbol}}
                </typography>
              </div>
              <div [id]="'lnOrderDetailCardRow3Col2_'+i" class="column">
                <typography [id]="'totalPrice_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_totalPrice}}
                </typography>
                <typography [id]="'totalPrice_'+i" variant="body-2" weight="medium">
                  {{lnOrder.totalNet | currency: currencySymbol}}
                </typography>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }
      @if (totalRecords > 0) {
        <div id="paginationContainerMobile" class="flex-container">
          <div id="mobilePagination" class="pagination">
            <ds-pagination
              [totalPages]="totalPages"
              paginationDisplay="small"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          </div>
        </div>
      }
    </div>
  } @else {
    <div id="emptyLnOrderDetailsList" class="no-results">
      {{appStrings.noEntriesFound}}
    </div>
  }

</div>
